(function() {
    'use strict';
    angular.module('wbDashboard')
.directive('historicalGraphAurea', ['$window', '$timeout', '$filter',
function($window, $timeout, $filter) {
    return {
        restrict: 'A',
        scope: {
            data: '=',
            config: '=?',
            hoverData: '=?',
            label: '@',
            onClick: '&'
        },
        templateUrl: "app/themes/aurea/directives/historical-graph/historical-graph.tpl.html",
        link: function(scope, el, attrs) {
            /*jshint validthis: true */

            /*jshint -W030 */
            scope.hoverData || (scope.hoverData = {});
            scope.config || (scope.config = {});
            /*jshint +W030 */

            scope.tipData = {
                active : {},
                min : {}
            };
            scope.days = 0;

            var historicalGraph = new HG(scope.config, el, scope.hoverData);

            scope.zoomFromPeriod = function(days) {
                scope.days = days;
                historicalGraph.zoomFromPeriod(days);
            };

            scope.$watch("data", function (data) {
                if (data && data.plotData.length) {

                    //this way data may be manipulated within the graph without triggering external watchers
                    var dataCopy = angular.copy(data);

                    if (!historicalGraph.rendered) {
                        scope.days = 0;
                        historicalGraph.render();
                    } else {
                        $timeout(function() {
                            if (scope.days) {
                                scope.zoomFromPeriod(scope.days);
                            } else {
                                scope.days = 0;
                            }
                        });
                    }
                    historicalGraph.refresh(dataCopy);
                }
            });

            function resize() {
                //on resize rebuild entire graph
                var $svg = el.find('svg');
                if (scope.data && $svg.is(':visible')) {
                    historicalGraph.destroy();
                    historicalGraph.render();

                    historicalGraph.refresh(scope.data);

                    $timeout(function() {
                        if (scope.days) {
                            scope.zoomFromPeriod(scope.days);
                        } else {
                            scope.days = 0;
                        }
                    });
                }
            }
            angular.element($window).on('resize', resize);

            scope.$on('$destroy', function () {
                clearD3();
            });
            function clearD3() {
                historicalGraph.destroy();
                angular.element($window).off('resize', resize);
            }


            function HG(config, el, hoverData) {
                var hg = this;
                
                hg.$el = $(el);
                //config items
                hg.charts = [{values:[{x:0, y:0}]}];
                hg.chartsAllMerged = [{x:0, y:0}];

                //object used to return current mouse over location data
                hg.hover = hoverData;
                hg.rendered = false;
                hg.c = {
                    height: null,
                    duration: 1000,
                    brush: "chart", //chart or bar
                    zoomEnabled: false,
                    zoomStretch: false,
                    zoomScale: 16,
                    toolTips: true,
                    aspectWidth: 16,
                    aspectHeight: 9,
                    scaleY: true,
                    simpleDates: null,
                    simpleDateResolution: "month",
                    margin: {
                        top: 20,
                        right: 60,
                        bottom: 30,
                        left: 60
                    }
                };
                angular.extend(hg.c, config);

                //svg elements
                hg.s = {};

                //measurements/calculations
                hg.m = {
                    scale: {x: null, y: null, xBrush: null, yBrush: null},
                    axis: {},
                    line: null,
                    area: null,
                    lineBrush: null,
                    areaBrush: null,
                };

                //initialization of graph
                hg.render = function() {

                    hg.measure.init();
                    hg.create.init();

                    hg.rendered = true;

                };

                //calculation methods
                hg.measure = {
                    init: function() {
                        hg.measure.dimensions();
                        hg.measure.axis();
                        hg.measure.paths();
                    },
                    dimensions: function() {
                        let elWidth;

                        try {
                            //often causes a jquery error
                            elWidth = hg.$el.width();
                        } catch(err) {
                            //fallback, close enough, will probably re-render very soon anyway
                            elWidth = $window.innerWidth * 2 / 3;
                        }

                        if (elWidth < 200) { elWidth = 200; }
                        // if (elWidth > 500) { elWidth = 500; }

                        hg.m.aspectWidth = hg.c.aspectWidth;
                        hg.m.aspectHeight = hg.c.aspectHeight;

                        hg.m.margin = hg.c.margin;
                        hg.m.width =  elWidth - hg.m.margin.left - hg.m.margin.right;
                        if (hg.c.height) {
                            if (typeof hg.c.height === "function") {
                                hg.m.height = hg.c.height();
                            } else {
                                hg.m.height = hg.c.height;
                            }
                        } else {
                            hg.m.height = Math.ceil((hg.m.width * hg.m.aspectHeight) / hg.m.aspectWidth) - hg.m.margin.top - hg.m.margin.bottom;
                        }
                        if (hg.m.height < 50) hg.m.height = 50;


                        hg.m.marginBrush = {
                            top: hg.m.height + hg.m.margin.top + hg.m.margin.bottom + 15,
                            left: hg.m.margin.left - 7,
                            right: hg.m.margin.right,
                            bottom: 60
                        };
                        hg.m.widthBrush = hg.m.width;
                        hg.m.heightBrush = 0;
                        if (hg.c.brush === "chart") {
                            hg.m.heightBrush = 100 - hg.m.marginBrush.bottom;
                        } else if (hg.c.brush === "bar") {
                            hg.m.marginBrush.bottom = 25;
                            hg.m.heightBrush = 5;
                        } else {
                            hg.m.marginBrush.bottom = 0;
                            hg.m.heightBrush = 0;
                        }
                    },
                    axis: function() {
                        hg.m.scale.x = d3.time.scale().range([0, hg.m.width]);
                        hg.m.scale.y = d3.scale.linear().range([hg.m.height, 0]);

                        hg.m.axis.x = d3.svg.axis().scale(hg.m.scale.x).orient("bottom");
                        if (hg.c.simpleDates) {
                            hg.m.axis.x.tickFormat(hg.measure.dateSimpleFormat);
                            hg.setSimpleXAxisLine();
                        } else {
                            hg.m.axis.x.ticks(4)
                                .tickFormat(hg.measure.dateFormat)
                                .outerTickSize(0);
                        }

                        hg.m.axis.y = d3.svg.axis().scale(hg.m.scale.y).orient("left").ticks(5)
                            .tickFormat(function (d) {
                                if (d <= -100 || 100 <= d) {
                                    d = parseFloat(d.toPrecision(3)); //force to 3 sig figs
                                    return d3.format("$s")(d).replace("k", "K");
                                } else if (-100 < d && d < 100) {
                                    return "$" + d.toFixed(1);
                                }
                                return "$" + d;
                            })
                            .innerTickSize(-hg.m.width * 3)
                            .outerTickSize(0)
                            .tickPadding(10);

                        hg.m.scale.xBrush = d3.time.scale().range([0, hg.m.widthBrush]);
                        hg.m.scale.yBrush = d3.scale.linear().range([hg.m.heightBrush, 0]);

                        hg.m.axis.xBrush = d3.svg.axis().scale(hg.m.scale.xBrush).orient("bottom").ticks(5).tickFormat(hg.measure.dateFormat).outerTickSize(0);
                    },
                    paths: function() {
                        //main chart chart
                        hg.m.line = d3.svg.line()
                            .interpolate("monotone")
                            .x(function (d) { return hg.m.scale.x(d.x); })
                            .y(function (d) { return hg.m.scale.y(d.y); });
                        hg.m.area = d3.svg.area()
                            .interpolate("monotone")
                            .x(function (d) { return hg.m.scale.x(d.x); })
                            .y0(hg.m.height)
                            .y1(function (d) { return hg.m.scale.y(d.y); });

                        hg.m.flatLine = d3.svg.line()
                            .interpolate("monotone")
                            .x(function (d) { return hg.m.scale.x(d.x); })
                            .y(hg.m.height);
                        hg.m.flatArea = d3.svg.area()
                            .interpolate("monotone")
                            .x(function (d) { return hg.m.scale.x(d.x); })
                            .y0(hg.m.height)
                            .y1(hg.m.height);

                        //brush area
                        if (hg.c.brush === "chart") {
                            hg.m.lineBrush = d3.svg.line()
                                .interpolate("monotone")
                                .x(function (d) { return hg.m.scale.xBrush(d.x); })
                                .y(function (d) { return hg.m.scale.yBrush(d.y); });
                            hg.m.areaBrush = d3.svg.area()
                                .interpolate("monotone")
                                .x(function (d) { return hg.m.scale.xBrush(d.x); })
                                .y0(hg.m.heightBrush)
                                .y1(function (d) { return hg.m.scale.yBrush(d.y); });
                        }
                    },
                    zoomScale: function() {
                        var dateRange, d1, d2;

                        dateRange = d3.extent(hg.m.scale.x.domain());
                        d1 = moment(dateRange[0]);
                        d2 = moment(dateRange[1]);
                        hg.m.zoomScale = d2.diff(d1, 'weeks') || hg.c.zoomScale;
                        if (hg.m.zoomScale > 16) hg.m.zoomScale--;

                        return hg.m.zoomScale;
                    },
                    dateFormat: d3.time.format.multi([
                        [".%L", function(d) { return d.getMilliseconds(); }],
                        [":%S", function(d) { return d.getSeconds(); }],
                        ["%I:%M", function(d) { return d.getMinutes(); }],
                        ["%I %p", function(d) { return d.getHours(); }],
                        ["%a %d", function(d) { return d.getDay() && d.getDate() != 1; }],
                        ["%b %d", function(d) { return d.getDate() != 1; }],
                        ["%b", function(d) { return d.getMonth(); }], //abbreviated month
                        ["%Y", function() { return true; }]
                    ]),
                    dateSimpleFormat: d3.time.format.multi([
                        ["Today", function(d) {
                            var now = new Date();
                            var same;
                            var sameMonthYear = now.getUTCFullYear()+""+now.getUTCMonth() === d.getUTCFullYear()+""+d.getUTCMonth();
                            var sameDay = now.getUTCDate() === d.getUTCDate();

                            if (hg.c.simpleDateResolution === "month") {
                                same = sameMonthYear;
                            } else if (hg.c.simpleDateResolution === "day") {
                                same = sameMonthYear && sameDay;
                            }

                            return same;

                        }],
                        ["%m/%Y", function(d) {
                            return Math.abs(d.getFullYear() - (new Date()).getFullYear()) < 2;
                        }],
                        ["%m/%Y", function() { return true; }]
                    ])
                };

                //create methods
                hg.create = {
                    init: function() {
                        hg.create.containers();
                        hg.create.gradient("hg-gradient-money", "#81D9D7");
                        hg.create.gradient("hg-gradient-blue", "#4ba9d6");
                        hg.create.gradient("hg-gradient-green", "#43a047");
                        hg.create.gradient("hg-gradient-gold", "#b6996a");
                        hg.create.gradientGray();
                        hg.create.chartAddAxis();
                        hg.create.brushSetup();
                        hg.create.hoverBoxSetup();
                        hg.create.hoverLineData();
                        hg.create.targetLine();
                        if (hg.c.toolTips) {
                            hg.create.toolTips();
                        }
                        if (hg.c.zoomEnabled) {
                            hg.create.zoom();
                        }
                    },
                    containers: function () {

                        var svgContainer = d3.select(hg.$el[0]).select('.svg-container');
                        hg.s.svg = svgContainer.select('svg');


                        //only necessary if not using viewBox
                        hg.s.svg
                            .attr("width", hg.m.width + hg.m.margin.left + hg.m.margin.right)
                            .attr("height", hg.m.height + hg.m.heightBrush + hg.m.margin.top + hg.m.margin.bottom + hg.m.marginBrush.bottom)
                        ;

                        hg.s.svg.defs = hg.s.svg.append("defs");

                        hg.s.svg.defs.append("clipPath")
                            .attr("id", "historicalClip")
                            .append("rect")
                            .attr("width", hg.m.width)
                            .attr("height", hg.m.height)
                        ;
                        //main chart
                        hg.s.main = hg.s.svg.append("g")
                            .attr("class", "focus")
                            .attr("transform", "translate(" + hg.m.margin.left + "," + hg.m.margin.top + ")");

                        //brush chart
                        hg.s.context = hg.s.svg.append("g")
                            .attr("class", "context")
                            .attr("transform", "translate(" + hg.m.marginBrush.left + "," + hg.m.marginBrush.top + ")");
                    },
                    gradient: function(id, color1, color2) {
                        if (!color2) color2 = "#808080";

                        hg.s.gradient || (hg.s.gradient = {}); // jshint ignore:line

                        hg.s.gradient[id] = hg.s.svg.defs
                            .append("linearGradient")
                            .attr("id", id)
                            .attr("x1", "80%")
                            .attr("y1", "0%")
                            .attr("x2", "100%")
                            .attr("y2", "100%")
                            .attr("spreadMethod", "pad");

                        hg.s.gradient[id].append("stop")
                            .attr("offset", "0%")
                            .attr("stop-color", color1)
                            .attr("stop-opacity", 1);

                        hg.s.gradient[id].append("stop")
                            .attr("offset", "50%")
                            .attr("stop-color", color1)
                            .attr("stop-opacity", 0.5);

                        hg.s.gradient[id].append("stop")
                            .attr("offset", "90%")
                            .attr("stop-color", color2)
                            .attr("stop-opacity", 0);
                    },
                    gradientGray: function() {
                        var id = "hg-gradient-gray";
                        hg.s.gradient[id] = hg.s.svg.defs
                            .append("linearGradient")
                            .attr("id", id)
                            .attr("x1", "0%")
                            .attr("y1", "0%")
                            .attr("x2", "100%")
                            .attr("y2", "100%")
                            .attr("spreadMethod", "pad");

                        hg.s.gradient[id].append("stop")
                            .attr("offset", "0%")
                            .attr("stop-color", "#313942")
                            .attr("stop-opacity", 1);
                        hg.s.gradient[id].append("stop")
                            .attr("offset", "90%")
                            .attr("stop-color", "#252C34")
                            .attr("stop-opacity", 1);
                    },
                    chartAddAxis: function () {
                        hg.s.xAxis = hg.s.main.append("g")
                            .attr("class", "x axis "+(hg.c.simpleDates?"simple":""))
                            .attr("transform", "translate(0," + hg.m.height + ")")
                            .call(hg.m.axis.x);
                        hg.s.yAxis = hg.s.main.append("g")
                            .attr("class", "y axis")
                            .attr("transform", "translate(0, 0)")
                            .call(hg.m.axis.y);
                    },
                    brushSetup: function () {
                        var brushClass;
                        //create brush and attach xBrush scale to it
                        hg.m.brush = d3.svg.brush()
                            .x(hg.m.scale.xBrush)
                            .on("brush", hg.brushCallback);

                        if (hg.c.brush === "chart") {
                            //setup mini chart for brush
                            brushClass = "x brush";
                            hg.s.context.append("path")
                                .data([[]])
                                .attr("class", "area")
                                .attr("fill", hg.utility.svgUrl("#hg-gradient-blue"))
                                .attr("d", hg.m.areaBrush);
                            hg.s.context.append("path")
                                .data([[]])
                                .attr("class", "line")
                                .attr("d", hg.m.lineBrush);
                        } else if (hg.m.brush || hg.c.brush === "bar") {
                            //setup scratch bar for brush
                            brushClass = "x brush bar";
                            hg.s.context.classed('bar', true);
                        }

                        //attach axis for brush
                        hg.s.context.append("g")
                            .attr("class", "x axis")
                            .attr("transform", "translate(0," + hg.m.heightBrush + ")")
                            .call(hg.m.axis.xBrush);

                        //init and configure brush
                        hg.s.brushGroup = hg.s.context.append("g")
                            .attr("class", brushClass)
                            .call(hg.m.brush);
                        hg.s.brushGroup.selectAll("rect")
                            .attr("y", -6)
                            .attr("height", hg.m.heightBrush + 7);
                        //prevent clicking on background of brush from deselecting brush
                        hg.s.brushGroup.select('.background').on("mousedown.brush", function() {
                            d3.event.stopImmediatePropagation();
                        }).on("touchstart.brush", function() {
                            d3.event.stopImmediatePropagation();
                        });
                        //move draggable box in front of handles
                        hg.s.brushGroup.append(function() {
                            return hg.s.brushGroup.selectAll(".extent").remove().node();
                        });

                        //add custom brush handles
                        hg.s.brushGroup.selectAll(".resize.w").append("circle").attr("class", "handle")
                            .attr("transform", "translate(-7," + hg.m.heightBrush / 2 + ")");
                        hg.s.brushGroup.selectAll(".resize.w").append("circle").attr("class", "handle-inside")
                            .attr("transform", "translate(-7," + hg.m.heightBrush / 2 + ")");
                        hg.s.brushGroup.selectAll(".resize.e").append("circle").attr("class", "handle")
                            .attr("transform", "translate(7," + hg.m.heightBrush / 2 + ")");
                        hg.s.brushGroup.selectAll(".resize.e").append("circle").attr("class", "handle-inside")
                            .attr("transform", "translate(7," + hg.m.heightBrush / 2 + ")");
                        //add custom brush handles - need donut path shape for better inner/outer stroke styling
                        //brushG.selectAll(".resize").append("path").attr("class", "handle")
                        //    .attr("transform", "translate(0," + height2 / 2 + ")")
                        //    .attr("d", donut(5, 10, 5, 10));
                        //set brush to full selected
                        hg.m.brush.extent(hg.m.scale.xBrush.domain());
                        hg.s.brushGroup.call(hg.m.brush);
                    },
                    hoverBoxSetup: function() {
                        hg.s.hoverAction = hg.s.svg.append("rect")
                            .attr("class", "hover-action")
                            .attr("transform", "translate(" + hg.m.margin.left + "," + hg.m.margin.top + ")")
                            .attr("width", hg.m.width)
                            .attr("height", hg.m.height);
                    },
                    zoom: function () {
                        //create zoom behavior and attach x scale for it to auto modify x scales domain on zoom
                        hg.m.zoom = d3.behavior.zoom()
                            .on("zoom", hg.zoomCallback);
                        hg.m.zoom.x(hg.m.scale.x);
                        // hg.m.zoom.xExtent(hg.m.scale.x.range()); //only d3 v4

                        hg.measure.zoomScale();
                        //limit amount can zoom in/out
                        hg.m.zoom.scaleExtent([1, hg.m.zoomScale]);

                        //disable wheel event
                        hg.s.hoverAction.call(hg.m.zoom)
                            .on("wheel.zoom", null)
                            .on("mousewheel.zoom", null);
                        if (hg.c.targetAmount) {
                            hg.s.hoverAction.on("dblclick.zoom", null);
                        }
                    },
                    targetLine: function() {
                        hg.s.targetline = {};
                        if (hg.c.targetAmount) {
                            hg.s.targetline.g = hg.s.svg.select('.focus .y.axis').insert('g', '.domain') //insert before hover-action
                                .attr("class", "target-line")
                            // .attr("transform", "translate(" + hg.m.margin.left + "," + hg.m.margin.top + ")")
                            ;
                            hg.s.targetline.line = hg.s.targetline.g.append("line")
                                .attr("x0", "-1000px")
                                .attr("x1", "3000px")
                            ;
                            hg.s.targetline.text = hg.s.targetline.g.append("text").text("Target");
                            hg.s.targetline.value = hg.s.targetline.g.append("text").text($filter('currency')(hg.c.targetAmount,'$',0));
                        }
                    },
                    hoverLineData: function () {
                        hg.s.hoverline = {};
                        hg.s.hoverline.g = hg.s.svg.insert('g', '.hover-action') //insert before hover-action
                            .attr("class", "hovergroup")
                            .attr("transform", "translate(" + hg.m.margin.left + "," + hg.m.margin.top + ")");
                        hg.s.hoverline.shade = hg.s.hoverline.g.append("rect")
                            .style("display", "none")
                            .attr("transform", "translate(0,0)")
                            .attr("width", hg.m.width + hg.m.margin.left + hg.m.margin.right)
                            .attr("height", hg.m.height)
                            .attr("fill", hg.utility.svgUrl(hg.utility.getGradient("gray")))
                        ;
                        hg.s.hoverline.line = hg.s.hoverline.g.append("line")
                            .attr("class", "hoverline")
                            .style("display", "none")
                            .attr("x1", 0).attr("x2", 0) // vertical line so same value on each
                            .attr("y1", 0).attr("y2", hg.m.height); // top to bottom
                        hg.s.hoverline.circle = hg.s.hoverline.g.append("circle")
                            .style("display", "none")
                            .attr("r", 4.5);
                        hg.s.hoverAction
                            .on("mouseover", hoverOnEvent)
                            .on("mouseout", hoverOffEvent)
                            .on("mousemove", hoverMoveEvent)

                            .on("touchstart", hoverOnEvent)
                            // Don't need to hide after touch, want line to stay there when let go
                            // When a outside spot is tapped, mouseout event will trigger the hide of the line
                            // .on("touchend", hoverOffEvent)
                            // .on("touchcancel", hoverOffEvent)
                            .on("touchmove", hoverMoveEvent)
                            ;
                        function hoverOnEvent() {
                            hg.s.hoverline.line.style("display", null);
                            hg.s.hoverline.circle.style("display", null);
                            hg.s.hoverline.shade.style("display", null);

                            //need to immediately initialize the line, the touchmove event takes a while to run
                            hoverMoveEvent.apply(this);
                        }
                        function hoverOffEvent() {
                            hg.s.hoverline.line.style("display", "none");
                            hg.s.hoverline.circle.style("display", "none");
                            hg.s.hoverline.shade.style("display", "none");

                            hg.hover.data = null;

                            if (hg.c.toolTips) {
                                hg.tipsHide();
                            }

                            $timeout(function() { scope.$apply(); });
                        }
                        function hoverMoveEvent() {
                            var x0, y0, indexActive, indexMin, indexMax, d0, d1, d, dataMin, dmax, tx, ty, mouse, domain;

                            var bisectorDate = d3.bisector(function(d) { return new Date(d.date); });

                            mouse = d3.mouse(this); //[x,y]
                            x0 = hg.m.scale.x.invert(mouse[0]); //date in microseconds of mouse location
                            y0 = hg.m.scale.y.invert(mouse[1]);

                            domain = hg.m.scale.x.domain(); //[min, max]
                            //point just to the left of current domain min
                            indexMin = bisectorDate.left(hg.charts[0].values, domain[0]);
                            //point just to the left of current domain max
                            indexMax = bisectorDate.right(hg.charts[0].values, domain[1]) - 1;
                            //determine active datapoint based on mouse location
                            indexActive = bisectorDate.left(hg.charts[0].values, x0, indexMin, indexMax);

                            //d is for data
                            if (indexActive === indexMin) {
                                d0 = hg.charts[0].values[indexActive];
                            } else {
                                d0 = hg.charts[0].values[indexActive - 1];
                            }
                            d1 = hg.charts[0].values[indexActive];

                            if (d0 && d1) {
                                //if position date is greater than the average date, use position data point
                                d = x0 > ((new Date(d0.date)) * 1 + (new Date(d1.date)) * 1) / 2 ? d1 : d0;
                            }

                            //position marker and line
                            if (d) {
                                tx = hg.m.scale.x(new Date(d.date));
                                ty = hg.m.scale.y(d.account_value);

                            } else {
                                tx = mouse[0];
                                ty = -100;
                            }

                            // hg.s.tooltip.g.attr("transform", "translate(" + tx + "," + margin.top + ")");
                            hg.s.hoverline.circle.attr("transform", "translate(" + tx + "," + ty + ")");
                            hg.s.hoverline.line.attr("x1", tx).attr("x2", tx); // vertical line so same value on each
                            hg.s.hoverline.shade.attr("transform", "translate("+tx+", 0)"); // vertical line so same value on each

                            hg.hover.data = {
                                dataMin: hg.charts[0].values[indexMin],
                                dataActive: d,
                                positionData: {x: x0, y: y0},
                                mouse: mouse
                            };

                            if (hg.c.toolTips) {
                                hg.tipsDisplay();
                            } else {
                                $timeout(function() { scope.$apply(); });
                            }
                        }

                    },
                    toolTips: function() {
                        var tipClass, light = "";

                        hg.s.tooltip = {};

                        if (hg.c.toolTips === "mini") {
                            tipClass = "historical-tip-mini";
                        } else {
                            tipClass = "historical-tip";
                        }
                        if (hg.c.light) {
                            light = " light";
                        }


                        hg.s.tooltip.tip = d3.tip()
                            .attr('class', 'd3-tip ' + tipClass + light)
                            .html(function(data) {
                                return hg.$el.find('.' + tipClass).html();
                            });
                        hg.s.svg.call(hg.s.tooltip.tip);
                    }
                };

                //update methods
                hg.update = {
                    updateGraphElements: function() {

                        //attach charts
                        var maxIndex = 6; //will be able to clear out up to 6 charts if they no longer exist

                        //clear out old data
                        for (var i=maxIndex;i>=0;i--) {
                            if (!hg.charts[i]) {
                                hg.s.main.select(".area-"+i)
                                    .transition()
                                    .duration(hg.c.duration)
                                    .attr("d", hg.m.flatArea).remove();

                                hg.s.main.select(".line-"+i)
                                    .transition()
                                    .duration(hg.c.duration)
                                    .attr("d", hg.m.flatLine).remove();
                            }
                        }

                        //add new data
                        hg.charts.forEach(function(chart, i) {
                            if (!hg.s.main.select(".area-"+i)[0][0]) {
                                hg.s.main.append("path")
                                    .data([hg.charts[i].values])
                                    .attr("class", "area area-" + i)
                                    .attr("clip-path", hg.utility.svgUrl("#historicalClip"))
                                    .attr("d", hg.m.flatArea)
                                ;
                                hg.s.main.append("path")
                                    .data([hg.charts[i].values])
                                    .attr("class", "line line-" + i)
                                    .attr("clip-path", hg.utility.svgUrl("#historicalClip"))
                                    .attr("d", hg.m.flatLine)
                                ;
                            }
                        });
                    },
                    domainRanges: function () {
                        hg.m.scale.x.domain(d3.extent(hg.chartsAllMerged.map(function(d) { return d.x; })));
                        hg.m.scale.y.domain(hg.utility.yExtentAdj(hg.chartsAllMerged));

                        //brush domain same as main
                        hg.m.scale.xBrush.domain(hg.m.scale.x.domain());
                        hg.m.scale.yBrush.domain(hg.m.scale.y.domain());
                    },
                    refreshSpaces: function(duration = hg.c.duration) {

                        hg.charts.forEach(function(chart, i) {
                            hg.s.main.select(".area-"+i)
                                .transition()
                                .duration(duration)
                                .attr("d", hg.m.area);

                            hg.s.main.select(".line-"+i)
                                .transition()
                                .duration(duration)
                                .attr("d", hg.m.line);
                        });

                        hg.s.main.select(".x.axis").transition().duration(duration).call(hg.m.axis.x);
                        hg.s.main.select(".y.axis").transition().duration(duration).call(hg.m.axis.y);
                    },
                    /**
                     * Data isn't set on initialization, only on refresh
                     * @param {Object} data
                     * @param {Array} data.plotData contains all the graphs to be graphed
                     */
                    setData: function(data) {
                        //update hg.charts by adding or removing multiple graphs till it matches
                        //the same number of graphs getting added
                        var maxIndex = Math.max(hg.charts.length, data.plotData.length) - 1;
                        for (var i=maxIndex;i>=0;i--) {
                            //start from end of array to can remove items from hg.charts
                            if (data.plotData[i]) {
                                hg.charts[i] || (hg.charts[i] = {}); // jshint ignore:line
                                hg.charts[i] = data.plotData[i];
                            } else if (hg.charts[i]) {
                                //deconstruct then remove item
                                hg.charts.splice(i, 1);
                            }
                        }

                        hg.chartsAllMerged = hg.charts.reduce((a, b) => [...a, ...b.values],[]);
                        hg.chartsAllMerged.sort((a,b) => a.x - b.x );

                    }
                };

                //rather than recreate all the elements, use the existing ones so the chart has a smooth transition when eventually updating the data on it
                hg.refresh = function(data) {
                    // http://bl.ocks.org/mbostock/3808234
                    // http://stackoverflow.com/a/33389648/65985


                    //handle 0 or 1 data points
                    angular.forEach(data.plotData, function(plot) {
                        if (!plot.values.length) {
                            var nowDate = moment();
                            plot.values.push({
                                date: nowDate.format("YYYY-MM-DD"),
                                value: null,
                                x: nowDate.valueOf(),
                                y: 0,
                            });
                            plot.values.push(plot.values[0]);
                        } else if (plot.values.length === 1) {
                            //if there's a single data point, duplicate it so graph has start and end points
                            plot.values.push(angular.copy(plot.values[0]));
                            plot.values[1].x += 1; //x requires slightly different coordinate
                        }
                    });

                    hg.update.setData(data);

                    hg.update.domainRanges();

                    if (hg.c.zoomEnabled) {
                        hg.measure.zoomScale();
                        hg.m.zoom.scaleExtent([1, hg.m.zoomScale]);
                        hg.m.zoom.x(hg.m.scale.x);
                    }

                    hg.setMaxYAxisLine();
                    if (hg.c.simpleDates) {
                        hg.setSimpleXAxisLine();
                    }

                    //update axis
                    hg.s.main.select(".x.axis").transition().duration(hg.c.duration).call(hg.m.axis.x);
                    hg.s.main.select(".y.axis").transition().duration(hg.c.duration).call(hg.m.axis.y);


                    hg.update.updateGraphElements();
                    //update graph data
                    hg.charts.forEach(function(chart, i) {
                        var fillId = hg.utility.getGradient(chart.color);
                        hg.s.main.select(".area-"+i).attr("fill", hg.utility.svgUrl(fillId));

                        hg.s.main.select(".area-"+i).data([chart.values])
                            .transition()
                            .duration(hg.c.duration)
                            .attr("d", hg.m.area);

                        hg.s.main.select(".line-"+i).data([chart.values])
                            .transition()
                            .duration(hg.c.duration)
                            .attr("d", hg.m.line);

                    });


                    //update brush, always use brush, so update it regardless
                    if (hg.m.brush || hg.c.brush) {
                        if (hg.c.brush === "chart") {
                            hg.s.context.select(".area").data([hg.charts[0].values])
                                .transition().duration(hg.c.duration).attr("d", hg.m.areaBrush)
                                .attr("fill", hg.utility.svgUrl(hg.utility.getGradient(hg.charts[0].color)));
                            hg.s.context.select(".line").data([hg.charts[0].values])
                                .transition().duration(hg.c.duration).attr("d", hg.m.lineBrush);
                        }

                        hg.s.context.select(".x.axis").transition().duration(hg.c.duration).call(hg.m.axis.xBrush);
                        hg.m.brush.extent(hg.m.scale.xBrush.domain());
                        hg.s.context.select(".x.brush").call(hg.m.brush);
                    }

                };


                hg.scaleYByData = function() {
                    //get data only between visible x domain
                    // http://stackoverflow.com/questions/13975237/update-the-y-axis-of-a-brushed-area-chart
                    var fromDate = hg.m.scale.x.domain()[0].getTime();
                    var toDate = hg.m.scale.x.domain()[1].getTime();
                    var dataFiltered = hg.chartsAllMerged.filter(function(d, i) {
                        if ( (d.x >= fromDate) && (d.x <= toDate) ) {
                            return true;
                        }});

                    hg.m.scale.y.domain(hg.utility.yExtentAdj(dataFiltered));

                    var dataY = dataFiltered.map((d)=>d.y);
                    hg.setMaxYAxisLine(d3.extent(dataY)[1]);

                };
                hg.setMaxYAxisLine = function(maxY, minY) {
                    //x axis is set and created with range and domain by now
                    var data, ticks;

                    if (hg.c.targetAmount && hg.m.scale.xBrush.domain().toString() === hg.m.scale.x.domain().toString()) {
                        hg.setTargetLine();

                        //only remove top tick
                        // ticks = hg.m.scale.y.ticks(5);
                        // ticks.pop();
                        // hg.m.axis.y.tickValues(ticks);

                        // angular.element(hg.s.yAxis.node()).addClass('target-line');
                        // maxY = hg.c.targetAmount;
                    } else {
                        // angular.element(hg.s.yAxis.node()).removeClass('target-line');
                    }

                    if (!maxY) {
                        data = hg.chartsAllMerged.map(function (d) {
                            return d.y;
                        });
                        [minY, maxY] = d3.extent(data);
                    }

                    if (hg.c.targetAmount) {
                        if (Math.abs(hg.m.scale.y(hg.c.targetAmount) - hg.m.scale.y(maxY)) > 20) {
                            //if there's at least 20 px of space between the target and the max graph,
                            //then show the maxY line for the data
                            //useful for partners
                            angular.element(hg.s.yAxis.node()).removeClass('hide-y-values');
                        } else {
                            //if there's not 20px of space bellow target line, don't show max line
                            ticks = hg.m.scale.y.ticks(5);
                            ticks.pop();
                            hg.m.axis.y.tickValues(ticks);
                            angular.element(hg.s.yAxis.node()).addClass('hide-y-values');
                            return;
                        }
                    }

                    if (maxY) {
                        ticks = hg.m.scale.y.ticks(5);
                        //remove top axis line
                        ticks.pop();
                        //add maximum
                        ticks.push(maxY);
                        hg.m.axis.y.tickValues(ticks);
                    }
                };
                hg.setTargetLine = function() {
                    hg.s.targetline.g.attr("transform", "translate(" + 0 + "," + hg.m.scale.y(hg.c.targetAmount) + ")");
                    hg.s.targetline.text.attr("dx", hg.m.scale.x(hg.m.scale.x.domain()[0]));
                    hg.s.targetline.value.attr("dx", hg.m.scale.x(hg.m.scale.x.domain()[1]));
                };
                hg.setSimpleXAxisLine = function() {
                    hg.m.axis.x.tickValues(hg.m.scale.x.domain());
                };
                hg.updateDayDomain = function() {
                    var days;
                    var [fromDate, toDate] = hg.m.scale.x.domain();
                    var [fullFromDate, fullToDate] = hg.m.scale.xBrush.domain();

                    //need to subtract 1 since it's always one more than the set clicked zoomFromPeriod
                    days = moment(toDate).diff(fromDate, 'days') - 1;
                    if (fromDate.getTime() === fullFromDate.getTime() && toDate.getTime() === fullToDate.getTime()) {
                        days = 0;
                    }

                    scope.days = days;
                };

                hg.tipsDisplay = function () {
                    var dataMin = hg.hover.data.dataMin,
                        dataActive = hg.hover.data.dataActive,
                        mouse = hg.hover.data.mouse,
                        xRange = hg.m.scale.x.range(),
                        tipThresholdL, tipThresholdR,
                        showContainer;

                    scope.tipData.active = dataActive;
                    scope.tipData.min = dataMin;


                    tipThresholdL = 120;
                    tipThresholdR = xRange[1] - tipThresholdL;

                    if (hg.c.toolTips === "mini") {

                        hg.s.tooltip.tip.direction('n').offset([0, 0]); //[y, x]
                        if (mouse[0] < tipThresholdL) {
                            hg.s.tooltip.tip.direction('ne').offset([0, 0]);
                        } else if (tipThresholdL <= mouse[0] && mouse[0] <= tipThresholdR) {
                            hg.s.tooltip.tip.direction('n').offset([0, 0]);
                        } else if (mouse[0] > tipThresholdR) {
                            hg.s.tooltip.tip.direction('nw').offset([0, 0]);
                        }

                        showContainer = hg.s.hoverline.line[0][0];

                    } else {

                        var positionData = hg.hover.data.positionData,
                            returnValue;

                        // position of tooltip info box
                        // this positions the box around the element based on mouse position0
                        if (positionData.y <= dataActive.account_value) { // tooltip over the line
                            if (mouse[0] < tipThresholdL) {
                                hg.s.tooltip.tip.direction('ne').offset([-20, -16]);
                            } else if (mouse[0] >= tipThresholdL && mouse[0] <= tipThresholdR) {
                                hg.s.tooltip.tip.direction('n').offset([-20, 0]);
                            } else if (mouse[0] > tipThresholdR) {
                                hg.s.tooltip.tip.direction('nw').offset([-20, 16]);
                            }
                        } else { // tooltip under the line
                            if (mouse[0] < tipThresholdL) {
                                hg.s.tooltip.tip.direction('se').offset([20, -16]);
                            } else if (mouse[0] >= tipThresholdL && mouse[0] <= tipThresholdR) {
                                hg.s.tooltip.tip.direction('s').offset([20, 0]);
                            } else if (mouse[0] > tipThresholdR) {
                                hg.s.tooltip.tip.direction('sw').offset([20, 16]);
                            }
                        }
                        returnValue = ( dataActive.close - ( dataActive.contributions - dataMin.contributions + dataMin.close ) ) / ( dataActive.contributions - dataMin.contributions + dataMin.close );
                        /* jshint eqnull: true */
                        if (dataActive.contributions == null) { returnValue = null; }
                        /* jshint eqnull: false */
                        else if (isNaN(returnValue)) { returnValue = 0; }

                        scope.tipData.returnValue = returnValue;

                        showContainer = hg.s.hoverline.circle[0][0];
                    }

                    //calculate tip data
                    $timeout(function() { scope.$apply(); });
                    //data, element to attach to
                    hg.s.tooltip.tip.show(scope.tipData, showContainer);
                };
                hg.tipsHide = function() {
                    hg.s.tooltip.tip.hide();
                    hg.s.tooltip.tip.style("left","-1000px");
                };

                hg.brushCallback = function() {
                    var dateDomain, valueDomain, scale;

                    // http://stackoverflow.com/questions/22873551/d3-js-brush-controls-getting-extent-width-coordinates
                    dateDomain = hg.m.brush.empty() ? hg.m.scale.xBrush.domain() : hg.m.brush.extent();
                    valueDomain = dateDomain.map(hg.m.scale.xBrush);

                    if (hg.c.zoomEnabled) {
                        //must be called before setting the dateDomain
                        scale = hg.m.width / (valueDomain[1] - valueDomain[0]);
                        hg.m.zoom
                            .scale(scale)
                            .translate([-(valueDomain[0]*scale), 0]);
                    }

                    //must be called after zoomEnabled to override with brush values
                    hg.m.scale.x.domain(dateDomain);
                    hg.scaleYByData();

                    hg.update.refreshSpaces(0);
                };

                hg.zoomCallback = function() {
                    // http://bl.ocks.org/mbostock/4015254
                    var e = d3.event; //e.translate();
                    var fullDateDomain, fullIntDomain, zoomDateDomain, zoomIntDomain, txMin, txMax, scale;
                    var zoom = hg.m.zoom;
                    var duration;

                    // //attempt to fix zoom out of range issues
                    fullDateDomain = hg.m.scale.xBrush.domain();
                    fullIntDomain = fullDateDomain.map(hg.m.scale.xBrush);
                    zoomDateDomain = hg.m.scale.x.domain();
                    zoomIntDomain = zoomDateDomain.map(hg.m.scale.xBrush);
                    txMin = Math.max(zoomIntDomain[0], fullIntDomain[0]);
                    txMax = Math.min(zoomIntDomain[1], fullIntDomain[1]);

                    if (txMin !== zoomIntDomain[0] || txMax !== zoomIntDomain[1]) {
                        if (hg.c.zoomStretch) {
                            scale = hg.m.width / (txMax - txMin);
                        } else {
                            scale = zoom.scale();
                        }
                        if (scale > hg.m.zoomScale) scale = hg.m.zoomScale;
                        if (txMin !== zoomIntDomain[0] && txMax !== zoomIntDomain[1]) {
                            zoom.translate([0,0]);
                            zoom.scale(1);
                        } else if (txMin !== zoomIntDomain[0]) {
                            //too low
                            zoom.translate([0, 0]);
                            txMax = hg.m.width / scale;
                        } else if (txMax !== zoomIntDomain[1]) {
                            txMin = txMax - (hg.m.width / scale);
                            zoom.translate([-(txMin*scale), 0]);
                        }
                        zoom.scale(scale);
                        hg.m.scale.x.domain([hg.m.scale.xBrush.invert(txMin), hg.m.scale.xBrush.invert(txMax)]);
                    }

                    //update the brush highlighted view, always update regardless
                    if (hg.m.brush || hg.c.brush) {
                        hg.m.brush.extent(hg.m.scale.x.domain());
                        hg.s.brushGroup.call(hg.m.brush);
                    }


                    if (e.sourceEvent && e.sourceEvent.type === "mousemove") {
                        //this is a drag event
                        duration = 0;
                    } else {
                        //this is a dbl click event
                        duration = 250;
                    }

                    hg.scaleYByData();
                    hg.updateDayDomain();
                    if (hg.c.simpleDates) {
                        hg.setSimpleXAxisLine();
                    }

                    //update of chart to zoomed bit
                    hg.update.refreshSpaces(duration);

                    return false;
                };

                hg.zoomFromPeriod = function(days) {
                    var toDate, fromDate, indexDate, dateDomain, valueDomain, scale;
                    var bisectorDate = d3.bisector(function(d) { return new Date(d.date); });

                    toDate = hg.m.scale.xBrush.domain()[1];
                    if (days > 0) {
                        fromDate = moment(toDate).subtract(days, 'days').toDate();
                        indexDate = bisectorDate.left(hg.chartsAllMerged, fromDate);
                        if (indexDate > 0) {
                            indexDate--;
                        }
                        fromDate = new Date(hg.chartsAllMerged[indexDate].date);
                    } else if (days === 0) {
                        fromDate = hg.m.scale.xBrush.domain()[0];
                    }

                    dateDomain = [fromDate, toDate];
                    valueDomain = dateDomain.map(hg.m.scale.xBrush);

                    if (hg.c.zoomEnabled) {
                        //must be called before setting the dateDomain
                        scale = hg.m.width / (valueDomain[1] - valueDomain[0]);
                        hg.m.zoom
                            .scale(scale)
                            .translate([-(valueDomain[0]*scale), 0]);
                    }

                    //must be called after zoomEnabled to override with brush values
                    hg.m.scale.x.domain(dateDomain);

                    //update the brush highlighted view
                    if (hg.m.brush || hg.c.brush) {
                        hg.m.brush.extent(hg.m.scale.x.domain());
                        hg.s.brushGroup.call(hg.m.brush);
                    }

                    hg.scaleYByData();
                    hg.updateDayDomain();

                    //update of chart to zoomed bit
                    hg.update.refreshSpaces();
                };

                hg.clear = function() {
                    var $svg = hg.$el.find('svg');
                    $svg.empty();
                };

                hg.destroy = function() {
                    if (hg.s.tooltip) {
                        hg.s.tooltip.tip.destroy();
                    }
                    hg.clear();
                };

                hg.utility = {
                    //add some padding so the graph doesn't hit the top or bottom
                    yExtentAdj: function (data) {
                        var yExtent, yExtentFinal, delta, mean, sum;
                        data = data.map(function(d) {
                            return d.y;
                        });
                        yExtent = d3.extent(data);

                        //make sure not to return [NaN, NaN]
                        if (yExtent.length < 2 || yExtent[0] === undefined || yExtent[1] === undefined) {
                            return [0,0];
                        }
                        delta = yExtent[1] - yExtent[0];

                        yExtentFinal = yExtent.slice(0);

                        if (delta === 0) {
                            yExtentFinal[0] *= 0.8;
                            yExtentFinal[1] *= 1.2;
                        } else {
                            yExtentFinal[0] -= (delta) * 0.2;
                            yExtentFinal[1] += (delta) * 0.1;
                        }
                        if ((yExtent[0] >= 0 && yExtentFinal[0] < 0) || !hg.c.scaleY) {
                            yExtentFinal[0] = 0;
                        }
                        if (hg.c.targetAmount) {
                            yExtentFinal[1] = hg.c.targetAmount;
                        }

                        return yExtentFinal;

                    },
                    //converts local url paths to absolute paths to deal with base path issues
                    //https://github.com/angular/angular.js/issues/8934
                    svgUrl: function(path) {
                        return "url('" + $window.location.href.replace(/#.*/, "") + path + "')";
                    },
                    getGradient: function(color) {
                        var fillId;
                        switch (color) {
                            case 'gray':
                                fillId = "#hg-gradient-gray";
                                break;
                            case 'gold':
                                fillId = "#hg-gradient-gold";
                                break;
                            case 'green':
                                fillId = "#hg-gradient-green";
                                break;
                            case 'money':
                                fillId = "#hg-gradient-money";
                                break;
                            case 'blue':
                            /* falls through */
                            default:
                                fillId = "#hg-gradient-blue";
                                break;
                        }
                        return fillId;
                    }
                };
            }

            //donut is lopsided, need better function
            //function donut(x, y, innerRadius, outerRadius) {
            //    y -= outerRadius;
            //    return 'M'+x+' '+y+'a'+outerRadius+' '+outerRadius+' 0 1 0 1 0m-1 '+(outerRadius - innerRadius)+'a'+innerRadius+' '+innerRadius+' 0 1 1 -1 0';
            //}

        }};
    }]);
})();
